import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetAiAssistantStatusQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
}>;


export type GetAiAssistantStatusQuery = { __typename?: 'Query', account?: { __typename?: 'Account', id: string, project?: { __typename?: 'Project', id: string, aiAssistant?: { __typename?: 'AiAssistant', status?: Types.AiAssistantStatus | null } | null } | null } | null };


export const GetAiAssistantStatus = /*#__PURE__*/ gql`
    query GetAiAssistantStatus($projectId: ID!) {
  account(by: {projectId: $projectId}) {
    id
    project(id: $projectId) {
      id
      aiAssistant {
        status
      }
    }
  }
}
    ` as unknown as DocumentNode<GetAiAssistantStatusQuery, GetAiAssistantStatusQueryVariables>;

          

          export const useGetAiAssistantStatusQuery = (options?:QueryHookOptions<GetAiAssistantStatusQuery, GetAiAssistantStatusQueryVariables>) => useQuery(GetAiAssistantStatus, options);

          

          export type GetAiAssistantStatusQueryOptions = QueryHookOptions<GetAiAssistantStatusQuery, GetAiAssistantStatusQueryVariables>;

          

          export const useGetAiAssistantStatusLazyQuery = (options?:LazyQueryHookOptions<GetAiAssistantStatusQuery, GetAiAssistantStatusQueryVariables>) => useLazyQuery(GetAiAssistantStatus, options);

          

          export type GetAiAssistantStatusQueryResult = ReturnType<typeof useGetAiAssistantStatusQuery>;

          
